import { FirefoxSVG, ChromeSVG, RightArrowSVG, EdgeSVG, OperaGXSVG } from "../../../assets/iconSvg";
import ButtonIcon from "../../../components/container/button";
import Carousel from "../../../components/container/carousel";
import HeadLayout from "../../../components/layout/RootLayout";
import { isEdge, isFirefox, isOperaGX } from "../../../utils/browerType";

const pageChildren = () => {
  const images = [
    "/turistai/image-1.png", 
    "/turistai/image-2.png", 
    "/turistai/image-3.png", 
    "/turistai/image-4.png", 
    "/turistai/image-5.png", 
    "/turistai/image-6.png", 
    "/turistai/image-7.png", 
    "/turistai/image-8.png", 
    "/turistai/image-9.png", 
    "/turistai/image-10.png"
  ];

  return (
    <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      {/* Hero Section */}
      <div className="flex flex-col md:flex-row gap-8 md:gap-12 mb-16">
        <div className="w-full md:w-1/2 flex flex-col">
          <div className="mb-8">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">TuristAI</h1>
            <p className="text-xl text-gray-700 dark:text-gray-300 mb-6">Asistente de viaje inteligente con OpenAI y Google Maps</p>
       
            <div className="flex flex-wrap gap-3 mb-8">
              <a href="https://appetize.io/app/b_txufdj7szntqg6crmrzjdcjmkm" className="inline-block">
                <ButtonIcon color={"#0071c2"} title="Live Demo"> 
                  <svg className="mr-2" xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 24 24">
                    <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 10l5 5l-5 5m5-5H4" />
                  </svg>
                </ButtonIcon>
              </a>
              
              <a href="/projects/turistai/downloads" className="inline-block">
                <ButtonIcon color={"#0071c2"} title="Descargar APK"> 
                  <svg className="mr-2" xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 24 24">
                    <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m17 13l-5 5m0 0l-5-5m5 5V6" />
                  </svg>
                </ButtonIcon>
              </a>
            </div>
        </div>
          
          <div className="bg-blue-50 dark:bg-blue-900/20 rounded-xl p-6 mb-8">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">Características destacadas</h2>
            <ul className="space-y-3 text-gray-700 dark:text-gray-300">
              <li className="flex items-start">
                <span className="text-blue-600 dark:text-blue-400 mr-2">•</span>
                <span>Speech to Text: Convierte tu voz en texto para interactuar sin necesidad de escribir</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 dark:text-blue-400 mr-2">•</span>
                <span>Text to Speech: Escucha las respuestas en voz alta</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 dark:text-blue-400 mr-2">•</span>
                <span>Asistente Virtual con inteligencia artificial</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 dark:text-blue-400 mr-2">•</span>
                <span>Traducción en 10 idiomas diferentes</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 dark:text-blue-400 mr-2">•</span>
                <span>Interfaz multi-idioma para usuarios internacionales</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 dark:text-blue-400 mr-2">•</span>
                <span>Integración con Google Maps para visualizar ubicaciones</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 dark:text-blue-400 mr-2">•</span>
                <span>Inicio personalizable según preferencias del usuario</span>
              </li>
            </ul>
          </div>
          
          <div className="bg-gray-50 dark:bg-gray-800/40 rounded-xl p-6">
            <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">Sobre el proyecto</h2>
            <p className="text-gray-600 dark:text-gray-400">
              TuristAI es una aplicación móvil diseñada para ser tu compañero de viaje ideal. Utilizando 
              la potencia de OpenAI, ofrece recomendaciones personalizadas, información local, traducción 
              en tiempo real y navegación integrada con Google Maps. Perfecta para viajeros que buscan 
              una experiencia más enriquecedora y sin barreras de idioma.
            </p>
          </div>
        </div>
        
        <div className="w-full md:w-1/2 flex items-center justify-center">
          <div className="w-full max-w-sm overflow-hidden rounded-xl shadow-lg bg-white dark:bg-gray-800">
            <Carousel images={images} />
          </div>
</div>
      </div>
      
      {/* Additional Information Section */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
        <div className="bg-blue-50 dark:bg-blue-900/20 p-6 rounded-xl">
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">Tecnologías</h3>
          <div className="space-y-2">
            <p className="flex items-center text-gray-700 dark:text-gray-300">
              <span className="w-4 h-4 mr-2 rounded-full bg-blue-600/20 flex-shrink-0"></span>
              React Native
            </p>
            <p className="flex items-center text-gray-700 dark:text-gray-300">
              <span className="w-4 h-4 mr-2 rounded-full bg-blue-600/20 flex-shrink-0"></span>
              OpenAI API
            </p>
            <p className="flex items-center text-gray-700 dark:text-gray-300">
              <span className="w-4 h-4 mr-2 rounded-full bg-blue-600/20 flex-shrink-0"></span>
              Google Maps API
            </p>
            <p className="flex items-center text-gray-700 dark:text-gray-300">
              <span className="w-4 h-4 mr-2 rounded-full bg-blue-600/20 flex-shrink-0"></span>
              Speech Recognition
            </p>
          </div>
        </div>
        
        <div className="bg-blue-50 dark:bg-blue-900/20 p-6 rounded-xl">
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">Idiomas soportados</h3>
          <div className="grid grid-cols-2 gap-2">
            <p className="text-gray-700 dark:text-gray-300">Español</p>
            <p className="text-gray-700 dark:text-gray-300">Inglés</p>
            <p className="text-gray-700 dark:text-gray-300">Francés</p>
            <p className="text-gray-700 dark:text-gray-300">Alemán</p>
            <p className="text-gray-700 dark:text-gray-300">Italiano</p>
            <p className="text-gray-700 dark:text-gray-300">Portugués</p>
            <p className="text-gray-700 dark:text-gray-300">Chino</p>
            <p className="text-gray-700 dark:text-gray-300">Japonés</p>
          </div>
        </div>
        
        <div className="bg-blue-50 dark:bg-blue-900/20 p-6 rounded-xl">
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">Plataforma</h3>
          <div className="flex items-center mb-3">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600 dark:text-blue-400 mr-2" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect>
              <line x1="12" y1="18" x2="12" y2="18"></line>
            </svg>
            <span className="text-gray-700 dark:text-gray-300">Android</span>
          </div>
          <p className="text-gray-600 dark:text-gray-400 text-sm">Versión mínima requerida: Android 7.0+</p>
        </div>
      </div>
    </div>
  );
};

function TuristAI() {
  return (
    <HeadLayout 
      title="TuristAI | Leonardo Capone" 
      description="Aplicación de asistente de viaje con inteligencia artificial, traducción en múltiples idiomas e integración con Google Maps para facilitar la experiencia del viajero."
      keywords="TuristAI, OpenAI, Google Maps, asistente de viaje, traducción, React Native, Speech to Text, Text to Speech"
    >
      {pageChildren()}
    </HeadLayout>
  );
}

export default TuristAI;
